import React from "react";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import Whychooseus from "../../Components/internal-pages/WhyChooseus";
import ClinetsLogoSlider from "../../Components/home/ClientsLogoSlider";
import { Helmet } from "react-helmet";

const Otherbrandcatalog =()=>{
    const CTAContent = [
        {
          pageName: "Other Brand",
          paragraphitalic: "",
          paragraphText:
            "Celebrate the spirit of Diwali with our premium corporate gifting range! From delectable gourmet treats to luxurious hampers, our thoughtfully curated selection is perfect for expressing gratitude and strengthening business bonds. Whether for clients, employees, or partners, find the ideal gift to illuminate relationships and make this festive season truly special.",
          ContactFormName: "Other Brand Catalog",
        },
      ];
    return(
        <>
           <Helmet>
            <title>eYantra Brand Catalog & Bulk Gifting</title>
            <meta name="description" content="Explore eYantra’s brand catalog with bulk corporate gifting, employee gifts, joining kits, onboarding kits, and welcome solutions for every occasion."/>
            <meta name="keywords" content="eyantra, brand catalog, corporate gifting, joining kits, rewards and recognitions, onboarding kits for employees, corporate gifts for employees, welcome kits, bulk gifting, employee gifts"/>
          </Helmet>
           <Ctapage data={CTAContent}/>
            <ClinetsLogoSlider/>
           <Whychooseus/>
        </>
    )
}

export default Otherbrandcatalog;